export enum SALES_POINTS {
	GALLERY = 'Galeria Sucholeska, ul. Obornicka 85, Suchy Las | pon‑pt 09:00‑19:00, sob. 9:00-15:00',
}

const DEFAULT_TEL = '61 852 45 72';

function resolveHostTel(): string {
	if (typeof window === 'undefined') {
		return DEFAULT_TEL;
	}
	const hostname = window.location.hostname;
	const hostConfig = window.__HOST_CONFIG__;
	const config = hostConfig?.[hostname] ?? hostConfig?.['default'];
	return config?.tel ?? DEFAULT_TEL;
}

export const OPENING_HOURS = {
	days: 'pon.‑pt. 09:00‑22:00, sob. 09:00‑20:00',
	tel: resolveHostTel(),
};
export const GROUPS_CONTACT = {
	mail: 'grupy@oskar.com.pl',
	tel: '+48 (61) 850 48 45',
};

export const AGENCY_CONTACT = {
	tel: '+48 61 850 15 08',
};
